var exports = {
  "k": "x4c3adb35--9f6c2a--container",
  "z": "x4c3adb35--9f6c2a--container-desktop",
};

module.exports = exports;
